<template>
  <div>
    <el-dialog width="75%" top="5px" center title="工作记录" :before-close="handleClose" :visible.sync="dialogVisible" append-to-body>
      <RecordSearch :source="source" @getFilterSource="getFilterSource"></RecordSearch>
      <div v-loading="loading" style="padding: 0 10px">
        <h4 v-show="filterSource.length===0" style="color: coral;text-align: center;">未查找到数据</h4>
        <el-row v-for="(item,index) in filterSource" style="margin-bottom:10px" :key="index">
          <TaskRecordCard :record.sync="filterSource[index]" :isCheckbox="false"></TaskRecordCard>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetRecordsByTaskId,
  GetRecordInfoByMainId
} from "@/api/modules/basicData/task";
import RecordSearch from "../Record/RecordSearch";
import TaskRecordCard from "../Record/TaskRecordCard";
import { mapMutations, mapState } from "vuex";
export default {
  name: 'WorkRecordDialog',
  components: {
    TaskRecordCard,
    RecordSearch
  },
  data() {
    return {
      dialogVisible: false,
      source: [],
      loading: false,
      filterSource: []
    };
  },

  computed: {
    ...mapState({})
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    OpenDialog(val) {
      this.dialogVisible = true;
      this.loading = true;
      GetRecordsByTaskId(val.join(","), 0).then(result => {
        if (result) {
          console.log("GetRecordsByTaskId", result);
          this.source = result;
          this.loading = false;
        }
      });
    },
    getFilterSource(val) {
      this.loading = true;
      this.$nextTick(() => {
        this.filterSource = val;
      });
      setTimeout(() => {
        this.loading = false;
      }, Math.max(val.length * 100, 1000));
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>